module.exports = __webpack_public_path__ + "images/a782769cd4a7ba180bcf2cd8fff15b69.png";